import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ContentPage, PageList } from "./types";

const CONTENT_PAGE_TAG = "CONTENT_PAGE";

export const contentPageApi = createApi({
  reducerPath: "pageApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/v1/pages/" }),
  tagTypes: [CONTENT_PAGE_TAG],
  endpoints: (builder) => ({
    getPages: builder.query<PageList, void>({
      query: () => "",
    }),
    getPageById: builder.query<ContentPage, string>({
      query: (id: string) => `${id}/`,
    }),
  }),
});

export const {
  useGetPageByIdQuery,
  useGetPagesQuery,
} = contentPageApi;
